import Cookies from 'js-cookie';

const LEGACY_SIGNATURE_KEY = 'email_signature';

function resolveUserId() {
  return (
    Cookies.get('userId') ||
    localStorage.getItem('userId') ||
    'anonymous'
  );
}

export function getEmailSignatureStorageKey(userId = resolveUserId()) {
  return `email_signature:${userId}`;
}

export function isBlankSignatureHtml(html) {
  const value = String(html || '');
  // Drawn signature images count as content even with no text.
  if (/<img\b[^>]*src=["'][^"']+["']/i.test(value)) return false;
  const text = value
    .replace(/<br\s*\/?>/gi, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, '')
    .trim();
  return !text;
}

export function buildDrawnSignatureImgHtml(dataUrl) {
  const src = String(dataUrl || '').trim();
  if (!src.startsWith('data:image/')) return '';
  return `<img data-sas-drawn-signature="1" src="${src}" alt="Signature" style="display:block;max-width:280px;height:auto;margin:8px 0;" />`;
}

export function wrapSignatureHtml(html) {
  const body = String(html || '').trim();
  if (!body) return '';
  if (/data-sas-email-signature/i.test(body)) return body;
  return `<div data-sas-email-signature="1" style="margin-top:12px;padding-top:12px;border-top:1px solid #e5e7eb;color:#374151;font-size:13px;line-height:1.6;">${body}</div>`;
}

export function getLocalEmailSignature(userId = resolveUserId()) {
  try {
    const key = getEmailSignatureStorageKey(userId);
    const scoped = localStorage.getItem(key);
    if (scoped != null) return scoped;

    // Migrate legacy shared key once per user.
    const legacy = localStorage.getItem(LEGACY_SIGNATURE_KEY);
    if (legacy) {
      localStorage.setItem(key, legacy);
      return legacy;
    }
    return '';
  } catch (error) {
    console.error('Error getting signature:', error);
    return '';
  }
}

export function setLocalEmailSignature(html, userId = resolveUserId()) {
  const key = getEmailSignatureStorageKey(userId);
  localStorage.setItem(key, String(html ?? ''));
  // Keep legacy key in sync for older code paths.
  localStorage.setItem(LEGACY_SIGNATURE_KEY, String(html ?? ''));
}

export function buildDefaultSignatureHtml({
  firstName,
  lastName,
  jobTitle,
  email,
  contact,
  companyName,
} = {}) {
  const name = [firstName, lastName].filter(Boolean).join(' ').trim();
  const lines = [
    name,
    jobTitle,
    companyName,
    email ? `Email: ${email}` : '',
    contact ? `Phone: ${contact}` : '',
  ].filter(Boolean);

  if (!lines.length) return '';
  return lines.map((line) => `<div>${escapeHtml(line)}</div>`).join('');
}

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
